'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:multiSelect');
}

var _invoke = require('../invoke');

/**
 *
 * @memberof train
 * @static
 * @name multiSelect
 * @param {Array} menus 菜单
 * @return {Promise}
 * @example
 *  hbnb.train.multiSelect([{
 *      label: '',
 *      value: '',
 *      active: false
 *  }])
 *      .then(function(menus) {
 *          menus = [{
 *              label: '',
 *              value: '',
 *              active: false
 *          }]
 *      });
 */
module.exports = function(menus) {
    if (process.env.NODE_ENV !== 'production') {
        debug('menus is %j', menus);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('train', 'multi_select', {
            menus: menus,
            callback: function(menus) {
                resolve(menus);
            }
        });
    });

    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/multi-select.js
// module id = 631
// module chunks = 0